import { validarCPFCNPJ } from "./validar-cpfcnpj"
import { stringNumeros } from "./string-numeros"

export const validarDocumentoTelefoneEmail = (campo: string) => {
    const letrasENumeros = campo.replace(/[^a-zA-Z0-9]/g, '')
    const apenasDigitos = campo.replace(/[^0-9]/g, '')
    if (validarCPFCNPJ(stringNumeros(apenasDigitos))) {
        return {
            cpfCnpj: stringNumeros(apenasDigitos)
        }
    } else if (/^[0-9]+$/.test(letrasENumeros)) {
        return {
            telefone: stringNumeros(apenasDigitos)
        }
    } else {
        return {
            email: campo
        }
    }
}